import {AxiosResponse} from 'axios';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';
import {pathOr} from 'ramda';

import {instanceGusaBackend} from 'libs/api';

let isClientIpSent = false;

/**
 * Callback for successful response to send client_ip to analytics
 * @param {AxiosResponse<any>} response - response
 * @returns {AxiosResponse<any>} response
 */
export const sendClientIp = (response: AxiosResponse<any>): AxiosResponse<any> => {
    if (!isClientIpSent && pathOr('', ['headers', 'x-real-ip-backend'], response)) {
        isClientIpSent = true;
        pushDataLayer({
            client_ip: response.headers['x-real-ip-backend'],
        });
    }
    return response;
};

instanceGusaBackend.interceptors.response.use(sendClientIp);
